import { ProgressBar, ProgressBarProps } from '../progress-bar';

export type ProgressBarCountdownProps = Omit<ProgressBarProps, 'variant'>;

export class ProgressBarCountdown extends ProgressBar {
	override get currentVariant() {
		if (this.percentage >= 66) return 'success';
		if (this.percentage >= 33) return 'warning';
		return 'danger';
	}
}

window.customElements.define('m-progress-bar-countdown', ProgressBarCountdown);

declare global {
	interface HTMLElementTagNameMap {
		'm-progress-bar-countdown': ProgressBarCountdown;
	}
}
